import React, { useState } from 'react';
import PropTypes from 'prop-types';

// Components
import { Dropzone } from '@client/components/fileUploaders/dropzone/dropzone';
import { ImageCropper } from '@client/components/fileUploaders/imageCropper/imageCropper';

// Constants
import {
  IMAGE_UPLOADER_PREVIEW,
  IMAGE_UPLOADER_CROP,
  IMAGE_UPLOADER_ADD,
  IMAGE_CHANGE,
  IMAGE_CROP,
  IMAGE_CURRENT,
} from '@client/definitions/constants';

// Styles
import styleHelper from '@client/shared/styles/styleHelper.scss';
import styles from './imageUploader.scss';

export const ImageUploader = ({ src, handleCrop }) => {
  const [currentView, setCurrentView] = useState(IMAGE_UPLOADER_PREVIEW);
  const [previewImage, setPreviewImage] = useState(src);
  const isBlob = src instanceof Blob;
  const previewSrc = isBlob ? URL.createObjectURL(src) : src;

  const handlePreviewImage = (blob) => setPreviewImage(blob);
  const handleCurrentView = (view) => setCurrentView(view);

  const handleReset = () => {
    setPreviewImage(src);
    setCurrentView(IMAGE_UPLOADER_PREVIEW);
  };

  const showLabel = (label) => {
    const labelType = {
      [IMAGE_UPLOADER_ADD]: IMAGE_CHANGE,
      [IMAGE_UPLOADER_CROP]: IMAGE_CROP,
      [IMAGE_UPLOADER_PREVIEW]: IMAGE_CURRENT,
    };
    return labelType[label];
  };

  return (
    <>
      <label className={styles.label}>{showLabel(currentView)}</label>

      {currentView === IMAGE_UPLOADER_ADD && (
        <Dropzone
          setCurrentView={handleCurrentView}
          setPreviewImage={handlePreviewImage}
          handleReset={handleReset}
        />
      )}

      {currentView === IMAGE_UPLOADER_CROP && (
        <ImageCropper
          previewImage={!isBlob ? previewImage : previewSrc}
          handleReset={handleReset}
          handleCrop={handleCrop}
          setCurrentView={handleCurrentView}
        />
      )}

      {currentView === IMAGE_UPLOADER_PREVIEW && (
        <>
          <img className={`${styles.currentImage}`} src={previewSrc} />
          <div className={`${styles.btnContainer}`}>
            <button
              className={`${styleHelper.btnPrimaryMd} ${styles.btn}`}
              type="button"
              aria-label={IMAGE_CHANGE}
              onClick={() => setCurrentView(IMAGE_UPLOADER_ADD)}
            >
              {IMAGE_CHANGE}
            </button>

            {!previewSrc.includes('default-images') && (
              <button
                className={`${styleHelper.btnPrimaryMd} ${styles.btn}`}
                type="button"
                aria-label={IMAGE_CHANGE}
                onClick={() => setCurrentView(IMAGE_UPLOADER_CROP)}
              >
                {IMAGE_CROP}
              </button>
            )}
          </div>
        </>
      )}
    </>
  );
};

ImageUploader.propTypes = {
  src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  handleCrop: PropTypes.func.isRequired,
};
